import { resourceReservationIdZodSchema } from "@@/shared/acquire/resources/resource-reservation-id";
import { z } from "zod";

const reservationCheckInCommandZodObject = z.object({
    _type: z.literal("RESERVATION_CHECK_IN_COMMAND"),
    resourceReservationId: resourceReservationIdZodSchema,
    forceCheckOutOfOtherReservations: z.coerce.boolean().optional(),
});

export type ReservationCheckInCommand = z.infer<
    typeof reservationCheckInCommandZodObject
>;
export { reservationCheckInCommandZodObject };
